var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "dialogopen",
      staticClass: "slide-verify",
      style: _vm.widthlable,
      attrs: { id: "slideVerify", onselectstart: "return false;" }
    },
    [
      _c("canvas", { ref: "canvas", attrs: { width: _vm.w, height: _vm.h } }),
      _vm._v(" "),
      _c("canvas", {
        ref: "block",
        staticClass: "slide-verify-block",
        attrs: { width: _vm.w, height: _vm.h }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "slide-verify-refresh-icon el-icon-refresh",
        on: { click: _vm.refresh }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "slide-verify-info",
          class: { fail: _vm.fail, show: _vm.showInfo },
          on: { click: _vm.refresh }
        },
        [_vm._v(_vm._s(_vm.infoText))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "slide-verify-slider",
          class: {
            "container-active": _vm.containerActive,
            "container-success": _vm.containerSuccess,
            "container-fail": _vm.containerFail
          },
          style: _vm.widthlable
        },
        [
          _c(
            "div",
            {
              staticClass: "slide-verify-slider-mask",
              style: { width: _vm.sliderMaskWidth }
            },
            [
              _c(
                "div",
                {
                  staticClass: "slide-verify-slider-mask-item",
                  style: { left: _vm.sliderLeft },
                  on: {
                    mousedown: _vm.sliderDown,
                    touchstart: _vm.touchStartEvent,
                    touchmove: _vm.touchMoveEvent,
                    touchend: _vm.touchEndEvent
                  }
                },
                [
                  _c("div", {
                    staticClass: "slide-verify-slider-mask-item-icon"
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "slide-verify-slider-text" }, [
            _vm._v(_vm._s(_vm.sliderText))
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65cba13c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65cba13c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Newcap.vue
// module id = null
// module chunks = 